import { createRoot } from "react-dom/client";
import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { featureFlags } from "./feature-flags";

import { App } from "./app";

const root = createRoot(document.getElementById("root") as HTMLElement);

async function enableMocking() {
  if (!featureFlags.mockServerEnabled) {
    return;
  }
  const { worker } = await import("./msw/browser");
  return worker.start({
    onUnhandledRequest: "bypass",
  });
}

enableMocking().then(() => {
  root.render(
    <HelmetProvider>
      <BrowserRouter>
        <Suspense>
          <App />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>,
  );
});
